import React from "react";

export const Spinner = () => {
  return (
    <div>
      <div className="spinner-wrapper">
        <div className="donut"></div>
      </div>
    </div>
  );
};

export default Spinner;
